/** IoT Manager — plumbing-room nodes (gateway-local). */
export const plumbingRoomNodeEndpoints = {
  list: '/v1/iot-manager/plumbing-room-nodes',
  one: (id: string) => `/v1/iot-manager/plumbing-room-nodes/${id}`,
} as const;
